import api from "@/helpers/api-rest/api.js";

const BASE = "/api/v1/site-identity";
const PUBLIC_BASE = "/api/v1/public/site-identity";

const FALLBACK_INSTITUTIONAL_LOGOS = [
  {
    url: require("@/assets/images/logo-financiado-union-europea.png"),
    alt: "Financiado por la Unión Europea - NextGenerationEU",
  },
  {
    url: require("@/assets/images/logo-minsterio-educacion-formacion-profecional-deportes-amarillo.jpg"),
    alt: "Ministerio de Educación, Formación Profesional y Deportes",
  },
  {
    url: require("@/assets/images/logo-plan-recuperacion-transformacion-resilencia.png"),
    alt: "Plan de Recuperación, Transformación y Resiliencia",
  },
  {
    url: require("@/assets/images/logo_gobierno_aragon.png"),
    alt: "Gobierno de Aragón",
  },
  {
    url: require("@/assets/images/logo_centros_excelencia.jpg"),
    alt: "Centros de Excelencia",
  },
];

const FALLBACK_MAIN_LOGO = {
  url: require("@/assets/images/logo-CEX.png"),
  alt: "CEX Logo",
};

const FALLBACK_LOGIN_BANNER = {
  url: require("@/assets/images/image-edificio.jpg"),
  alt: "Edificio CEX",
};

let cachedIdentity = null;
let fetchPromise = null;

function buildFallbackIdentity() {
  return {
    institutional_logos: [...FALLBACK_INSTITUTIONAL_LOGOS],
    main_logo: { ...FALLBACK_MAIN_LOGO },
    login_banner: { ...FALLBACK_LOGIN_BANNER },
  };
}

function normalizePublicData(data) {
  const fallback = buildFallbackIdentity();
  const institutional = Array.isArray(data?.institutional_logos)
    ? data.institutional_logos.filter((item) => item?.url)
    : [];

  return {
    institutional_logos:
      institutional.length > 0 ? institutional : fallback.institutional_logos,
    main_logo: data?.main_logo?.url ? data.main_logo : fallback.main_logo,
    login_banner: data?.login_banner?.url
      ? data.login_banner
      : fallback.login_banner,
  };
}

export function clearSiteIdentityCache() {
  cachedIdentity = null;
  fetchPromise = null;
}

export async function loadSiteIdentity({ force = false } = {}) {
  if (!force && cachedIdentity) {
    return cachedIdentity;
  }

  if (!force && fetchPromise) {
    return fetchPromise;
  }

  fetchPromise = api
    .get({ url: PUBLIC_BASE, withLoading: false })
    .then((response) => {
      const data = response?.data?.data || {};
      cachedIdentity = normalizePublicData(data);
      return cachedIdentity;
    })
    .catch(() => {
      cachedIdentity = buildFallbackIdentity();
      return cachedIdentity;
    })
    .finally(() => {
      fetchPromise = null;
    });

  return fetchPromise;
}

export function applyLoginBannerCssVariable(banner) {
  const url = banner?.url || FALLBACK_LOGIN_BANNER.url;
  document.documentElement.style.setProperty(
    "--auth-side-panel-bg-image",
    `url('${url}')`
  );
}

export default {
  fetchPublic() {
    return api.get({ url: PUBLIC_BASE, withLoading: false });
  },

  getAdmin() {
    return api.get({ url: BASE });
  },

  syncSection(section, items = []) {
    return api.put({
      url: `${BASE}/${section}`,
      data: { items },
    });
  },

  toggleItem(itemId, isActive) {
    return api.patch({
      url: `${BASE}/items/${itemId}`,
      data: { is_active: isActive },
    });
  },

  loadSiteIdentity,
  clearSiteIdentityCache,
  applyLoginBannerCssVariable,
  FALLBACK_MAIN_LOGO,
};
